'use client';

import { ReactNode } from 'react';
import { PageSharedDataContext } from '../../hooks/usePageDataAdapter';
import { useStatusPageSharedData } from '../../hooks/useStatusPageSharedData';

export const StatusPageDataProvider = ({
  children,
  sessionId,
}: {
  children: ReactNode;
  sessionId: string;
}) => {
  const { detailItems, items, total } = useStatusPageSharedData(sessionId);

  const value = {
    detailItems,
    items,
    total,
    isRecurrence: false,
  };

  return (
    <PageSharedDataContext.Provider value={value}>
      {children}
    </PageSharedDataContext.Provider>
  );
};